/**
 * Импортируйте конфиги только из этого файла, а не из app.config!
 */

interface IConfig {
  env: string | undefined;
  isDev: boolean;
  apiURI: string;
  subscribesURI: string;
  filestorage: string;
  domainUrl: string;
  sentry?: {
    dsn: string;
  };
}

import * as configLocal from './config';
import * as devCfg from './app.config.dev';
import * as prereCfg from './app.config.staging';
import * as prodCfg from './app.config.release';
import { businessConfig } from './business.config';

let configResult: IConfig = configLocal.config;

switch (window.location.host) {
  case 'testpro.enty.io':
    configResult = devCfg.config as IConfig;
    break;
  case 'prepro.enty.io':
    configResult = prereCfg.config as IConfig;
    break;
  case 'pro.enty.io':
    configResult = prodCfg.config as IConfig;
    break;
}

export const config = configResult;
export { businessConfig };
